import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material';
import DefaultUptimeTheme from 'component/theme/defaultTheme';

export interface StyledAttachmentProps {
  theme: typeof DefaultUptimeTheme;
  disabled?: boolean;
}

export const StyledAttachment = styled('div')<StyledAttachmentProps>`
  ${({ theme, disabled }: StyledAttachmentProps) => `
 
  ${
    !disabled
      ? `
      div {
        text-decoration: none;
      }
      a {
        color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
        cursor: pointer;
        text-decoration: underline;
        font-weight: 400;
      }
      a:hover {
        color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
        cursor: pointer;
      }
      `
      : `
      a {
        color: ${theme.uptimeColors.generalColors.button.link.enabled};
        text-decoration: none;
      }
      a:hover {
        color: ${theme.uptimeColors.generalColors.button.link.enabled};
        text-decoration: none;
      }
      `
  }
  }`}
`;

export const AttachmentWrapper = muiStyled('div')<{ disabled?: boolean }>(({ theme, disabled }) => ({
  '.dropzone': {
    padding: '12px',
    backgroundColor: theme.palette.grey.A100,
    cursor: disabled ? 'default' : 'pointer',
    '&:hover': {
      backgroundColor: disabled ? 'inherit' : theme.palette.primary.hover,
      '& > .MuiBox-root > .MuiBox-root': {
        backgroundColor: disabled ? 'inherit' : theme.palette.primary.main,
      },
      '& .MuiTypography-body1': {
        color: disabled ? 'inherit' : theme.palette.primary.main,
      },
      '& .MuiLink-root': {
        textDecoration: disabled ? 'none' : 'underline',
      },
    },
  },
}));
